module.exports = __webpack_public_path__ + "static/media/Bicocca - white_Black.35867785.jpg";